module.exports = __webpack_public_path__ + "media/images/country_flags/so-5923e6d14f3e4d4f5fb285a446ba4743.png";